import Status from "./Status.vue";
import { pluginify } from "./../../util";
export default pluginify(Status);
export { Status };
